import React, { Component } from 'react'
import './styles.scss'
import { firestore } from '../../firebase/firebase-utils'
import { Image, Spinner, Accordion } from 'react-bootstrap'
import AllComments from './all.comments'
import Likes from './likes'
import Saved from './save'
import Comment from './comment'
import Answer from './answer'
import Delete from './delete.post'

class Comments extends Component {
    constructor() {
        super();
        this.state = {
            query: null,
            loader: true,
            answers: []
        }
    }

    getQuery = () => {
        var docRef = firestore.collection("queries").doc(this.props.match.params.docid);
        docRef.get().then((doc) => {
            if (doc.exists) {
                this.setState({ query: { ...doc.data(), docid: doc.id } })
                if (doc.data().category === "QUERY") {
                    this.getAnswers(doc.id)
                }
            } else {
                console.log("No such document!");
            }
        }).catch((error) => {
            console.log("Error getting document:", error);
        });
        this.setState({ loader: false })
    }

    getAnswers = (docid) => {
        firestore.collection("answers").where('queryid', '==', docid).orderBy('order', 'desc').onSnapshot((querySnapshot) => {
            if (querySnapshot.docs.length !== 0) {
                var query = querySnapshot.docs.map(doc => {
                    return {
                        ...doc.data(),
                        docid: doc.id
                    }
                });
                this.setState({ answers: query })
            }
        })
    }

    getFullComments = (docid) => {
        this.props.history.push('/community/' + docid)
    }
    componentDidMount = () => {
        this.getQuery();
    }
    render() {
        return (
            <div className="Comments">
                {this.state.loader ? <center><Spinner animation="border" variant="primary" /></center>
                    :
                    this.state.query === null ? null :
                        <>
                            <p>Posted by&nbsp;&nbsp; <span className="postedBy"><Image src={this.state.query.userimage} className="profileImg" fluid />&nbsp;{this.state.query.username}</span></p>
                            <br />
                            <div className="queryContainer">
                                <h5>{this.state.query.title}</h5>
                                <div className='queryDescrip' dangerouslySetInnerHTML={{ __html: this.state.query.discrp }}></div>
                                {!this.state.query.code ? null :
                                    <>
                                    code:
                                    <div className="scrollMenu Querydescrip">
                                        <div style={{ padding: '10px' }} dangerouslySetInnerHTML={{ __html: this.state.query.code }}></div>
                                    </div>
                                </>
                                }
                            </div>
                            <br />
                            {this.state.query.docid && this.state.query.title ?
                                <p className="footerdiv" style={{ float: 'right', cursor: 'pointer' }}>
                                    <Answer docid={this.state.query.docid} collection="answers" reload={true}/>
                                </p> : null
                            }
                            <br />
                            {this.state.query.category === "FEED"
                                ?
                                <AllComments docid={this.props.match.params.docid} collection="queries" />
                                :
                                this.state.answers.length === 0 ? <p>No answers posted 😢 </p> :
                                    this.state.answers.map((query) => (
                                        <Accordion>
                                            <div key={query.docid}>
                                                <div className="profile">
                                                    <Image src={query.userimage} />
                                                    <div>
                                                        <p style={{ fontFamily: 'Poppins', fontSize: '14px', color: '#057BD0' }}>{query.username}
                                                            <br /><span style={{ fontSize: '12px', fontFamily: 'Viga', color: 'gray' }}>{new Date(query.order).toISOString()}</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="cardDiv">
                                                    <h5>{query.title}</h5>
                                                    <div className="queryDescrip" dangerouslySetInnerHTML={{ __html: query.discrp }}></div>
                                                    {!query.code ? null :
                                                        <>
                                                        code:
                                                        <div className="scrollMenu Querydescrip">
                                                            <div style={{ padding: '10px' }} dangerouslySetInnerHTML={{ __html: query.code }}></div>
                                                        </div>
                                                    </>
                                                    }
                                                    <hr />
                                                    <div className="cardFooter">
                                                        <p className="footerdiv" style={{ float: 'left' }}><Delete docid={query.docid} collection="answers" reload={true} /></p>
                                                        <p className="footerdiv"><Saved docid={query.docid} collection="answers" /></p>
                                                        <p className="footerdiv"><Likes docid={query.docid} collection="answers" /></p>
                                                        <Accordion.Toggle style={{ backgroundColor: 'transparent', outline: 'none' }} eventKey={query.order} className="footerdiv">
                                                            <Comment docid={query.docid} collection="answers" />
                                                        </Accordion.Toggle>
                                                    </div>
                                                    <Accordion.Collapse style={{ padding: '10px' }} eventKey={query.order}>
                                                        <AllComments docid={query.docid} collection="answers" />
                                                    </Accordion.Collapse>
                                                </div>
                                            </div>
                                        </Accordion>
                                    ))
                            }
                        </>
                }
            </div>
        )
    }

}

export default Comments
